import { render, staticRenderFns } from "./Manufacturing.vue?vue&type=template&id=688ab478&scoped=true"
import script from "./Manufacturing.vue?vue&type=script&lang=js"
export * from "./Manufacturing.vue?vue&type=script&lang=js"
import style0 from "./Manufacturing.vue?vue&type=style&index=0&id=688ab478&prod&scoped=true&lang=css"
import style1 from "./Manufacturing.vue?vue&type=style&index=1&id=688ab478&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688ab478",
  null
  
)

export default component.exports